import { ACCOUNTS_ERROR, CREATE_ACCOUNT, CREATING_ACCOUNT, DELETE_ACCOUNT, DELETING_ACCOUNT, GET_ACCOUNTS, GETTING_ACCOUNTS } from "../types"

const initialState = {
    accounts: [],
    loadingAccounts: false,
    accountsError: null,
    creatingAccount: false,
    createdAccount: null,
    deletingAccount: false,
    deletedAccount: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_ACCOUNTS:
        return {
            ...state,
            loadingAccounts:action.payload,
            // fetchingMembers:false
        }
        case GET_ACCOUNTS:
        return{
            ...state,
            loadingAccounts:false,
            accountsError: false,
            accounts: action.payload,
        }
        case CREATING_ACCOUNT:
        return {
            ...state,
            creatingAccount:action.payload,
            // fetchingMembers:false
        }
        case CREATE_ACCOUNT:
        return{
            ...state,
            creatingAccount:false,
            accountsError: false,
            createdAccount: action.payload,
        }
        case DELETING_ACCOUNT:
        return {
            ...state,
            deletingAccount:action.payload,
        }
        case DELETE_ACCOUNT:
        return{
            ...state,
            deletingAccount:false,
            accountsError: false,
            deletedAccount: action.payload,
        }
        case ACCOUNTS_ERROR:
        return{
            ...state,
            loadingAccounts:false,
            creatingAccount:false,
            deletingAccount:false,
            accountsError: action.payload 
        }
        default: return state
    }

}